const MenuCategoryTypes =  {
    FETCH_MENUCATEGORY_START : 'FETCH_MENUCATEGORY_START',
    FETCH_MENUCATEGORY_SUCCESS : 'FETCH_MENUCATEGORY_SUCCESS',
    FETCH_MENUCATEGORY_FAILURE : 'FETCH_MENUCATEGORY_FAILURE',
}

export default MenuCategoryTypes;